const DEFAULT_OBSTACLES = [
  ".app-header",
  ".app-footer",
  ".list-pagination-bar",
  ".list-pagination-page-size-top",
];

export const FIXED_DROPDOWN_ITEM_HEIGHT = 37;
export const FIXED_DROPDOWN_DEFAULT_WIDTH = 140;

type FixedDropdownPositionOptions = {
  width?: number;
  itemCount?: number;
  itemHeight?: number;
  padding?: number;
  gap?: number;
  obstacleSelectors?: string[];
};

export const getFixedDropdownPosition = (
  triggerRect: DOMRect,
  {
    width = FIXED_DROPDOWN_DEFAULT_WIDTH,
    itemCount = 2,
    itemHeight = FIXED_DROPDOWN_ITEM_HEIGHT,
    padding = 8,
    gap = 6,
    obstacleSelectors = DEFAULT_OBSTACLES,
  }: FixedDropdownPositionOptions = {}
): { top: number; left: number } => {
  const dropdownHeight = itemCount * itemHeight + 2;

  let bottomLimit = window.innerHeight - padding;
  let topLimit = padding;

  obstacleSelectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.height <= 0) return;

      if (rect.top > triggerRect.top && rect.top < bottomLimit) {
        bottomLimit = rect.top - padding;
      }

      if (rect.bottom <= triggerRect.top && rect.bottom > topLimit) {
        topLimit = rect.bottom + padding;
      }
    });
  });

  const spaceBelow = bottomLimit - triggerRect.bottom - gap;
  const spaceAbove = triggerRect.top - topLimit - gap;
  const openUp = spaceBelow < dropdownHeight && spaceAbove > spaceBelow;

  let top = openUp
    ? triggerRect.top - gap - dropdownHeight
    : triggerRect.bottom + gap;

  if (top < topLimit) {
    top = topLimit;
  }

  if (top + dropdownHeight > bottomLimit) {
    top = Math.max(topLimit, bottomLimit - dropdownHeight);
  }

  let left = triggerRect.right - width;
  if (left < padding) {
    left = padding;
  }

  return { top, left };
};
